﻿
import global from '../../../../../shared/utils/global.js';
import { formatZuluTime } from '../../../../../shared/utils/timeformats.js';
import { formatCoordinate, getAddressFromCoordinates } from '../../../../../shared/utils/coordinateformats.js';
import { getUsers } from "../../../../users/views/customers.api.js";
import { updateTruck } from "../unitdiagrams/repeaters/units.api.js";


import { hideLoading, showLoading } from '../../../../../shared/components/modal.js';
let map, marker; // global variables for maps (leaflet)

async function getCompanyDrivers() {
  const users = await getUsers({
    pathCustomerId: global.parentCustomerId,
    inclChild: true,
    limit: 0,
    sort: 'name',
  });

  return (users || [])
    .filter(user => user.userRole === 'Driver')
    .sort((a, b) => {
      const customerCompare = (a.customerName || '').localeCompare(b.customerName || '');
      if (customerCompare !== 0) return customerCompare;

      return (a.name || '').localeCompare(b.name || '');
    });
}

async function populateDriverNameDropdown() {
  const driverNameOptions = document.getElementById('drivernameoptions');
  if (!driverNameOptions) return;

  driverNameOptions.innerHTML = '';

  const drivers = await getCompanyDrivers();

  drivers.forEach(driver => {
    const option = document.createElement('option');

    option.value = driver.name || '';
    option.label = driver.customerName
      ? `${driver.name} (${driver.customerName})`
      : driver.name || '';

    option.dataset.userId = driver.userId || '';
    option.dataset.customerId = driver.customerId || '';
    option.dataset.customerName = driver.customerName || '';
    option.dataset.emailAddress = driver.emailAddress || '';

    driverNameOptions.appendChild(option);
  });

  console.log('Driver dropdown users:', drivers);
}

function displayUnitInfo(selectedUnit) {

  let unitInfo = document.getElementById(`unitinfo${selectedUnit.unitId}`);
  if (unitInfo) {
    unitInfo.parentNode.removeChild(unitInfo);
    //while (unitInfo.hasChildNodes()) {
    //    unitInfo.removeChild(unitInfo.lastChild);
    //}
  }
  unitInfo = document.createElement('div');
  unitInfo.id = `unitinfo${selectedUnit.unitId}`;
  unitInfo.className = 'unitinfopane';
  unitInfo.canClose = true;
  unitInfo.onclick = function (e) {
    unitInfo.canClose = false;
    e.stopImmediatePropagation();
  };

  const unitInfoFragment = document.createDocumentFragment();

  const unitInfoDiv = createUnitInfoElement(selectedUnit);
  const unitDriverInfoDiv = createUnitDriverInfoElement(selectedUnit);
  const unitMapDiv = createUnitMapElement(); ///@@check hier

  unitInfoFragment.appendChild(unitInfoDiv);
  unitInfoFragment.appendChild(unitDriverInfoDiv);
  unitInfoFragment.appendChild(unitMapDiv);

  unitInfo.appendChild(unitInfoFragment);

  let displayUnit = document.getElementById(`unit${selectedUnit.unitId}`);
  displayUnit.appendChild(unitInfo);

  initialiseMap('unitmap');

  const rawLat = selectedUnit?.location?.latitude;
  const rawLon = selectedUnit?.location?.longitude;

  const location = {
    latitude: formatCoordinate(rawLat),
    longitude: formatCoordinate(rawLon)
  };

  // Validate the formatted coords before calling showUnitOnMap
  if (!isNaN(location.latitude) && !isNaN(location.longitude)) {
    showUnitOnMap(location);
  } else {
    console.warn(`Invalid location for unit ${selectedUnit.unitId || selectedUnit.imei}:`, location);
  }

  displayUnit.scrollIntoView();
}

function initialiseMap(mapDiv) {

  if (map) {
    map.remove(); // This removes the existing map and cleans up event listeners
    map = null; // Reset the map variable so it can be re-initialized
  }

  // create a new map instance
  map = L.map(mapDiv, {
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: 'topleft'
    }
  }).setView([-33.97823, 22.45808], 10);

  // add an OpenStreetMap tile layer
  L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);

  setTimeout(() => {
    map.invalidateSize();
  }, 100);
}

function showUnitOnMap(pos) {

  if (map) {
    const customIcon = L.divIcon({
      className: 'map-icon'
    });
    if (marker != null) {
      map.removeLayer(marker);
    }
    marker = L.marker({ lat: pos.latitude, lng: pos.longitude }, { icon: customIcon }).addTo(map);
    marker.setLatLng({ lat: pos.latitude, lng: pos.longitude });
    marker.setIcon(customIcon);
    map.invalidateSize();
    map.setView({ lat: pos.latitude, lng: pos.longitude });
    map.invalidateSize();
  }
}

function createAssignDriverButtonElement(unit) {

  const assignDriverButton = document.createElement('button');
  assignDriverButton.id = 'assigndriverbutton';
  assignDriverButton.type = 'button';
  const assignDriverButtonClasses = ['btn', 'btn-primary', 'btn-block'];
  assignDriverButton.classList.add(...assignDriverButtonClasses);
  let editMode = false;
  if (!unit.driverName) {
    assignDriverButton.textContent = "New Driver"; //"Assign Driver"
  } else {
    assignDriverButton.textContent = "Edit Driver";
    editMode = true;
  }
  assignDriverButton.onclick = async function (e) {
    e.stopImmediatePropagation();
    await openDriverForm(unit, editMode);
  };

  return assignDriverButton;
}

function createUnitInfoElement(selectedUnit) {

  let unitInfoDiv = document.createElement('div');
  unitInfoDiv.id = `unitinfo${selectedUnit.unitId}`;
  unitInfoDiv.className = 'paneframe';

  let unitInfoContainerDiv = createUnitInfoContainerElements(selectedUnit);
  unitInfoDiv.appendChild(unitInfoContainerDiv);

  return unitInfoDiv;
}

function createUnitInfoContainerElements(selectedUnit) {
  let unitInfoContainerDiv = document.createElement('div');
  unitInfoContainerDiv.className = 'unitpanecontainer';

  let unitInfoHeaderDiv = createUnitInfoHeaderDiv(selectedUnit);
  unitInfoContainerDiv.appendChild(unitInfoHeaderDiv);

  const unitInfoDiv = createUnitInfoDiv(selectedUnit);
  unitInfoContainerDiv.appendChild(unitInfoDiv);

  // Start fetching the address asynchronously without blocking UI rendering
  updateAddressAsync(selectedUnit, unitInfoDiv, selectedUnit?.location?.latitude, selectedUnit?.location?.longitude);

  return unitInfoContainerDiv;
}

function createUnitInfoHeaderDiv(selectedUnit) {
  let unitInfoHeaderDiv = document.createElement('div');
  //let unitInfoHeaderDivClasses = ['unitinfoheader', 'editunitinfo'];
  const unitInfoHeaderDivClasses = ['unitinfoheader'];
  unitInfoHeaderDiv.classList.add(...unitInfoHeaderDivClasses);

  unitInfoHeaderDiv.onclick = function (e) {
    e.stopImmediatePropagation();
    openEditUnitForm(selectedUnit);
  };

  let unitIcon = document.createElement('svg');
  unitIcon.className = 'trucktrailer-icon';

  let unitName = document.createElement('h6');
  unitName.innerText = selectedUnit.name;

  unitInfoHeaderDiv.appendChild(unitIcon);
  unitInfoHeaderDiv.appendChild(unitName);

  return unitInfoHeaderDiv;
}

function createUnitInfoDiv(selectedUnit) {
  const unitInfoDiv = document.createElement('div');
  unitInfoDiv.className = 'unitinfo';

  // Speed Info
  const unitSpeedDiv = document.createElement('div');
  unitSpeedDiv.id = `unitinfospeed${selectedUnit.imei}`;
  const unitSpeedLabel = document.createElement('b');
  unitSpeedLabel.innerText = "Speed: ";
  const unitSpeed = document.createTextNode(
    selectedUnit.location && selectedUnit.speed !== undefined
      ? `${selectedUnit.speed} km/h`
      : 'Not Available'
  );
  unitSpeedDiv.appendChild(unitSpeedLabel);
  unitSpeedDiv.appendChild(unitSpeed);
  unitInfoDiv.appendChild(unitSpeedDiv);

  // Location Info (with placeholder)
  const unitLocationDiv = document.createElement('div');
  unitLocationDiv.id = `unitinfolocation${selectedUnit.imei}`;
  const unitLocationLabel = document.createElement('b');
  unitLocationLabel.innerText = "Location: ";
  const unitLocationText = document.createTextNode("Loading location...");
  unitLocationDiv.appendChild(unitLocationLabel);
  unitLocationDiv.appendChild(unitLocationText);
  unitInfoDiv.appendChild(unitLocationDiv);

  // Last Message Info
  const unitLastMessageDiv = document.createElement('div');
  unitLastMessageDiv.id = `unitinfotimeupdated${selectedUnit.imei}`;
  const unitLastMessageLabel = document.createElement('b');
  unitLastMessageLabel.innerText = "Time Updated: ";
  //const unitLastMessageText = document.createTextNode(formatZuluTime(selectedUnit.location.recordTimestamp));
  const unitLastMessageText = document.createTextNode(
    selectedUnit.location && selectedUnit.location.recordTimestamp !== undefined
      ? formatZuluTime(selectedUnit.location.recordTimestamp)
      : 'Not Available'
  );
  unitLastMessageText.id = 'unitinfodate';
  unitLastMessageDiv.appendChild(unitLastMessageLabel);
  unitLastMessageDiv.appendChild(unitLastMessageText);
  unitInfoDiv.appendChild(unitLastMessageDiv);

  return unitInfoDiv;
}

async function updateAddressAsync(selectedUnit, unitInfoDiv, latitude, longitude) {
  const unitLocationDiv = unitInfoDiv.querySelector(`#unitinfolocation${selectedUnit.imei}`);

  // Validate coordinates first
  const lat = parseFloat(latitude);
  const lon = parseFloat(longitude);
  const validCoords = !isNaN(lat) && !isNaN(lon);

  try {
    if (validCoords) {
      const address = await getAddressFromCoordinates(lat, lon);
      unitLocationDiv.childNodes[1].nodeValue = address;
    } else {
      unitLocationDiv.childNodes[1].nodeValue = "No GPS location";
      console.warn(`Invalid coordinates for unit ${selectedUnit.imei}: (${latitude}, ${longitude})`);
    }
  } catch (error) {
    unitLocationDiv.childNodes[1].nodeValue = "Not available";
    console.error('Error updating address:', error);
  }
}


const createUnitDriverInfoElement = (unit) => {

  const unitDriverInfoDiv = document.createElement('div');
  unitDriverInfoDiv.id = 'driverinfo';
  unitDriverInfoDiv.className = 'paneframe';
  if (unit.type === 'truck' || unit.unitType === 'TRUCK') {
    const unitDriverInfoContainerDiv = createUnitDriverInfoContainerElements(unit);
    unitDriverInfoDiv.appendChild(unitDriverInfoContainerDiv);
  }
  return unitDriverInfoDiv;
};

function createUnitDriverInfoContainerElements(unit) {

  const existingContainer = document.getElementById('driverinfocontainer');
  if (existingContainer) {
    existingContainer.remove(); // Remove the old container
  }

  const unitDriverInfoContainerDiv = document.createElement('div');
  unitDriverInfoContainerDiv.id = 'driverinfocontainer';
  unitDriverInfoContainerDiv.className = 'panecontainer';

  if (unit.driverName) {
    const driverInfoDiv = document.createElement('div');

    const driverNameHeader = document.createElement('div');
    driverNameHeader.id = `drivername${unit.unitId}`;
    driverNameHeader.className = 'drivername';
    driverNameHeader.innerText = unit.driverName || "";

    const driverMobileNoDiv = document.createElement('div');
    driverMobileNoDiv.id = `drivercontactno${unit.unitId}`;
    driverMobileNoDiv.className = 'drivermobile';
    driverMobileNoDiv.innerText = unit.driverContactNumber || "";

    const driverOfficeNoDiv = document.createElement('div');
    driverOfficeNoDiv.id = `driverofficeno${unit.unitId}`;
    driverOfficeNoDiv.className = 'drivermobile';
    driverOfficeNoDiv.innerText = unit.officeContactNumber || "";

    driverInfoDiv.appendChild(driverNameHeader);
    driverInfoDiv.appendChild(driverMobileNoDiv);
    driverInfoDiv.appendChild(driverOfficeNoDiv);
    unitDriverInfoContainerDiv.appendChild(driverInfoDiv);

  }

  const userRole = global.userRole;
  const serviceAgentAccessLevel = global.serviceAgentAccessLevel;
  if (userRole === 'Administrator' || (userRole === 'ServiceAgent' && serviceAgentAccessLevel === 'Administrator')) {
    const assignDriverButtonElement = createAssignDriverButtonElement(unit);
    unitDriverInfoContainerDiv.appendChild(assignDriverButtonElement);
  }

  return unitDriverInfoContainerDiv;
}

function createUnitMapElement(unit) {

  let unitInfoMapDiv = document.createElement('div');
  unitInfoMapDiv.id = 'unitinfomap';
  unitInfoMapDiv.className = 'paneframe';

  let unitMapContainerDiv = createUnitMapContainerElement('unitmapcontainer', 'unitmap', 'unitmap', unit);
  unitInfoMapDiv.appendChild(unitMapContainerDiv);

  return unitInfoMapDiv;
}

function createUnitMapContainerElement(mapcontainer, mapDiv, mapDivClass) {

  let unitMapContainerDiv = document.createElement('div');
  unitMapContainerDiv.id = mapcontainer;
  unitMapContainerDiv.className = 'panecontainer';
  unitMapContainerDiv.onclick = function (e) {
    e.stopImmediatePropagation();
  };

  let unitMapDiv = document.createElement('div');
  unitMapDiv.id = mapDiv;
  unitMapDiv.className = mapDivClass;

  unitMapContainerDiv.appendChild(unitMapDiv);

  return unitMapContainerDiv;
}

async function openDriverForm(unit, editMode) {

  document.body.style.cursor = 'wait';
  document.getElementById("driverform").reset();

  await populateDriverNameDropdown();

  const drivermodal = document.getElementById('drivermodal');

  const formTitle = document.getElementById('driverformtitle');
  if (formTitle && editMode) {
    formTitle.textContent = 'EDIT DRIVER';
    document.getElementById('drivername').value = unit.driverName || "";
    document.getElementById('drivercontactno').value = unit.driverContactNumber || "";
    document.getElementById('driverofficeno').value = unit.officeContactNumber || "";
  } else if (formTitle) {
    formTitle.textContent = 'NEW DRIVER';
  }

  const driverNameInput = document.getElementById('drivername');
  driverNameInput.onchange = function () {
    const selectedOption = Array.from(document.getElementById('drivernameoptions').options)
      .find(option => option.value === driverNameInput.value);

    if (!selectedOption) return;

    const contactNumber = selectedOption.dataset.contactNumber;

    if (contactNumber) {
      document.getElementById('drivercontactno').value = contactNumber;
    }
  };

  const closeModal = document.getElementById("closenewdrivermodal");
  closeModal.onclick = function () {
    drivermodal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == drivermodal) {
      drivermodal.style.display = "none";
    }
  };

  document.body.style.cursor = 'default';

  let driverform = document.getElementById('driverform');
  driverform.onsubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await submitDriverForm(unit);
  };

  document.getElementById("drivermodal").style.display = "block";
}

// function openEditDriverForm(unit) {

//     document.body.style.cursor = 'wait';

//     let editdrivermodal = document.getElementById('editdrivermodal');

//     let span = document.getElementById("closeeditdrivermodal");
//     span.onclick = function () {
//         editdrivermodal.style.display = "none";
//     };

//     window.onclick = function (event) {
//         if (event.target == editdrivermodal) {
//             editdrivermodal.style.display = "none";
//         }
//     };

//     let editdriverform = document.getElementById('editdriverform');
//     editdriverform.onsubmit = async (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         submitEditDriverForm(unit);
//     }

//     document.body.style.cursor = 'default';

//     document.getElementById('editdrivername').value = unit?.driverName || "";
//     document.getElementById('editdrivercontactno').value = unit?.driverContactNumber || "";
//     document.getElementById('editdrivercontactno').value = unit?.driverContactNumber || "";
//     document.getElementById("editdrivermodal").style.display = "block";
// }

// async function submitNewDriverForm() {

//     //document.body.style.cursor = 'wait';
//     //$('#container').overlayMask();
//     document.getElementById("loadingBoxText").innerHTML = "Updating driver data... ";
//     $("#loadingBox").modal({
//         backdrop: "static", //remove ability to close modal with click
//         keyboard: false, //remove option to close with keyboard
//         show: true //Display loader!
//     });

//     let truck = {};
//     truck.unitId= document.getElementById('newdrivertruckid').value;
//     truck.driverName = document.getElementById('drivername').value;
//     truck.driverContactNumber = document.getElementById('drivercontactno').value;
//     //driver.icon = document.getElementById('driverIcon').get(0);
//     //driver.icon = icon;
//     const updatedDriver = updateDriver(truck);

//     document.getElementById("drivermodal").style.display = "none";

//     //$('#container').overlayMask('hide');
//     document.body.style.cursor = 'default';
//     $("#loadingBox").modal("hide");

//     return false;
// }

async function submitDriverForm(unit) {

  document.getElementById("loadingBoxText").innerHTML = "Updating driver data... ";
  showLoading();
  const truck = {};
  truck.Id = unit.unitId;
  truck.customerId = unit.customerId;
  const driverData = {};
  driverData.driverName = document.getElementById('drivername').value;
  driverData.driverContactNumber = document.getElementById('drivercontactno').value;
  driverData.officeContactNumber = document.getElementById('driverofficeno').value;

  const updatedUnitDriver = await updateTruck(truck, driverData);
  if (updatedUnitDriver) {
    const driverName = document.getElementById(`drivername${unit.unitId}`);
    if (driverName) {
      driverName.innerText = driverData.driverName;
      document.getElementById(`drivercontactno${unit.unitId}`).innerText = driverData.driverContactNumber;
      document.getElementById(`driverofficeno${unit.unitId}`).innerText = driverData.officeContactNumber;
    } else {
      const driverInfoDiv = document.getElementById('driverinfo');
      if (driverInfoDiv) {
        const unitDriverInfoContainerDiv = createUnitDriverInfoContainerElements(unit);
        driverInfoDiv.appendChild(unitDriverInfoContainerDiv);
      }
    }

    unit.driverName = driverData.driverName;
    unit.driverContactNumber = driverData.driverContactNumber;
    unit.officeContactNumber = driverData.officeContactNumber;
  }

  document.getElementById("drivermodal").style.display = "none";
  //$('#container').overlayMask('hide');
  document.body.style.cursor = 'default';
  hideLoading();

  return false;
}

function submitEditUnitForm() {

  //document.body.style.cursor = 'wait';
  //$('#container').overlayMask();

  document.getElementById("loadingBoxText").innerHTML = "Updating unit data... ";
  showLoading();

  let unit = {};
  unit.unitId = document.getElementById('eufUnitId').value;
  unit.name = document.getElementById('eufUnitName').value;

  document.getElementById("editunitmodal").style.display = "none";

  $('#container').overlayMask('hide');
  hideLoading();
  document.body.style.cursor = 'default';

  return false;
}

async function editUnit(unit) {

  let updatedUnitName = await updateUnitName(unit);
  let updatedTrailerName = false;
  if (unit.trailerId > 0) {
    updatedTrailerName = await updateTrailerName(unit);
  } else {
    updatedTrailerName = true;
  }

  if (updatedUnitName && updatedTrailerName)
    updateUnitNameChangeNotification(unit);
  else
    console.log("pressuretrackJS: editUnit - UNIT NAME NOT UPDATED");
}


function openEditUnitForm(selectedUnit) {

  //document.body.style.cursor = 'wait';
  //$('#container').overlayMask();

  const editunitmodal = document.getElementById('editunitmodal');
  document.getElementById('editunitheader').innerText = "EDIT UNIT";
  document.getElementById('editunitlabel').innerText = "Unit Name";

  const closeEditUnit = document.getElementById("closeeditunitmodal");
  closeEditUnit.onclick = function () {
    editunitmodal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == editunitmodal) {
      editunitmodal.style.display = "none";
    }
  };

  let editunitform = document.getElementById('editunitform');
  editunitform.addEventListener('submit', async function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitEditUnitForm();
  });

  $('#container').overlayMask('hide');
  hideLoading();
  document.body.style.cursor = 'default';

  document.getElementById('eufUnitId').value = selectedUnit.unitId;
  document.getElementById('eufUnitName').value = selectedUnit.name;
  if (selectedUnit.isTrailer)
    document.getElementById('eufTrailerId ').value = selectedUnit.trailerId;
  else
    document.getElementById('eufTrailerId').value = 0;

  document.getElementById("editunitmodal").style.display = "block";
}



export { displayUnitInfo, createUnitMapContainerElement, initialiseMap, showUnitOnMap };
